import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";

export interface ReattributionContainer {
  id: string;
  containerLabel: string;
}

export interface ReattributionStreamOption {
  id: string;
  name: string;
}

interface UnmergeContainerReattributionProps {
  containers: ReattributionContainer[];
  /** The split streams (original raws) a container can be assigned to. */
  streamOptions: ReattributionStreamOption[];
  /** containerId → chosen original-raw id. */
  assignments: Record<string, string>;
  onChange: (containerId: string, wasteStreamRawId: string) => void;
}

/**
 * Per-container picker shown on unmerge: each container on the merged stream is
 * assigned to one of the split streams. Defaults are seeded by the caller (the
 * first split stream), so leaving this untouched reproduces the legacy
 * follow-the-first behavior.
 */
export const UnmergeContainerReattribution = ({
  containers,
  streamOptions,
  assignments,
  onChange,
}: UnmergeContainerReattributionProps) => {
  if (containers.length === 0) return null;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Assign {containers.length} container{containers.length === 1 ? "" : "s"} to a split stream
      </Typography>
      <Stack spacing={1}>
        {containers.map((container) => (
          <Box
            key={container.id}
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}
          >
            <Typography variant="body2" sx={{ flexShrink: 0 }}>
              {container.containerLabel}
            </Typography>
            <Select
              size="small"
              value={assignments[container.id] ?? ""}
              onChange={(e) => onChange(container.id, e.target.value)}
              sx={{ minWidth: 240 }}
            >
              {streamOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
